/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

.add-oxygen-dialog {
  .MuiPaper-root {
    width: 470px;
    height: 300px;
  }

  .add-oxygen-dialog-confirmed {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    .check-circle {
      width: 52px;
      height: 52px;
    }
  }
}
